import React, {useContext} from 'react';
import {AppBar, Box, Button, Container, Toolbar} from '@material-ui/core';
import {Link, useHistory} from 'react-router-dom';
import {LogoText} from 'components/icons/icons';
import {AuthContext} from 'context/AuthContext';
import {makeStyles} from '@material-ui/core/styles';
import FaceIcon from '@material-ui/icons/Face';

const useNavStyles = makeStyles(theme => ({
    fixedAppBar: {
        width: '100%',
    },
    toolbar: {
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '0',
            paddingRight: '0',
        },
    },
}));

const OnboardingNavBar = () => {
    const classes = useNavStyles();
    const {logOut} = useContext(AuthContext);
    const history = useHistory();
    const masquerade = sessionStorage.getItem('admin.masquerade');
    const reset = () => {
        sessionStorage.removeItem('admin.masquerade');
        history.go(0);
    };

    return (
        <AppBar position='fixed' className={classes.fixedAppBar}>
            <Toolbar className={classes.toolbar}>
                <Container maxWidth='xl'>
                    <Box display='flex' alignItems='center'>
                        <Box flexShrink={1}></Box>
                        <Box flexGrow={1}>
                            <Link to='/'>
                                <LogoText height='35' width='180' />
                            </Link>
                        </Box>
                        <Box minWidth='1.25rem'></Box>
                        {masquerade ? (
                            <Button
                                variant='contained'
                                color='warning'
                                title='Click to reset'
                                onClick={reset}
                                style={{marginRight: '1em'}}
                                startIcon={<FaceIcon />}
                            >
                                Acting as {masquerade}
                            </Button>
                        ) : null}
                        <Box>
                            <Link to='/signin' style={{textDecoration: 'none'}}>
                                <Button
                                    variant='contained'
                                    color='secondary'
                                    data-cy='signin-header'
                                    onClick={logOut}
                                    style={{
                                        paddingTop: '.6em',
                                        paddingBottom: '.6em',
                                    }}
                                >
                                    <Box
                                        component='span'
                                        style={{lineHeight: '1.1rem'}}
                                    >
                                        Switch Accounts
                                    </Box>
                                </Button>
                            </Link>
                        </Box>
                    </Box>
                </Container>
            </Toolbar>
        </AppBar>
    );
};

export default OnboardingNavBar;
export {OnboardingNavBar};
